/* eslint-disable @typescript-eslint/no-explicit-any */
import { root } from 'elc-universal-utils';
import { Service } from './Service';

interface IServiceManifest {
    isLazy: boolean;
    views: string[];
    queries: string[];
    events: string[];
    start(appConfig: any): Promise<any>;
}
interface IServiceManifestOptions {
    views?: string[];
    events?: string[];
    queries?: string[];
    isLazy?: boolean;
}

const defaultManifestOptions = {
    views: [],
    events: [],
    queries: [],
    isLazy: true
};

export const createServiceManifest = <T extends Service = Service>(
    manifestOptions: IServiceManifestOptions = defaultManifestOptions,
    serviceLoadFn?: Function,
    serviceKey?: string
): IServiceManifest => {
    const options = { ...defaultManifestOptions, ...manifestOptions };

    root.ServiceRegistry = root.ServiceRegistry || {};

    // A service is completely unloaded in the beginning. It's definition
    // consists just of an isLoaded flag, a manifest object detailing what does it
    // offer publicly(queries, events listened for, views) and a method to dynamically load it's core.

    const ServiceManifest = {
        ...options,
        start: async (appConfig = {}) => {
            if (options.isLazy && serviceLoadFn && serviceKey) {
                const { diContainer, serviceNames } = await serviceLoadFn();

                const serviceInstance: T = diContainer.get(serviceNames[serviceKey]);
                serviceInstance.register();
                await serviceInstance.start(appConfig);

                return serviceInstance;
            }
        }
    };

    return ServiceManifest;
};
